import { formatDate } from "../../../utils/dateFormatter";
import { formatUserName } from "../../../utils/emailTouserName";
import { SparcWalkRowData } from "../../../types/sparcWalk";
import { APISparcWalkData } from "../SparcWalkTypes";

/**
 * Normalize the API payload into the row shape consumed by the UI and mobile filters
 */
export const toSparcWalkRowData = (item: APISparcWalkData): SparcWalkRowData => {
  const category = item.SPARC_Category_Selected ?? "N/A";
  const zone = item.Zone;
  const createdRaw = item.Created || "";
  const modifiedRaw = item.Modified || "";
  const year = createdRaw ? new Date(createdRaw).getFullYear().toString() : "";

  return {
    id: item.ID,
    details: `${category} - ${zone}`,
    date: createdRaw ? formatDate(createdRaw) : "N/A",
    by: formatUserName(item.Created_By),
    status: item.status,
    zone,
    created: createdRaw ? formatDate(createdRaw) : "N/A",
    createdby: formatUserName(item.Created_By),
    modified: modifiedRaw ? formatDate(modifiedRaw) : "N/A",
    modifiedby: formatUserName(item.Modified_By),
    action: item.status,
    // Additional fields for filtering
    category,
    createdRaw,
    modifiedRaw,
    Created_By: item.Created_By,
    Modified_By: item.Modified_By,
    period: item.Period,
    week: item.Week,
    year,
  };
};
